import { ChainId } from '@uniswap/smart-order-router'

const CHAINS: ChainId[] = Object.values(ChainId) as number[]

// Workaround for upstream using enums incorrectly
export const AUTO_ROUTER_SUPPORTED_CHAINS: ChainId[] = CHAINS.filter((id) => typeof id === 'number')
